import { Dispatch, SetStateAction, useCallback } from 'react'
import { StockUnionType } from 'types/stock'
import { getUpdateSchedulesFunction } from 'components/Templates/product/default/ProductEditDefaultTemplate'
import { StoreDefaultScheduleType } from 'types/storeDefault'

const useDeleteDefaultSchedule = (
  setDailySchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>,
  setPreorderSchedules: Dispatch<SetStateAction<StoreDefaultScheduleType[]>>
): ((index: number, type: StockUnionType) => void) => {
  return useCallback(
    (index: number, type: StockUnionType) => {
      const update = getUpdateSchedulesFunction(type, setDailySchedules, setPreorderSchedules)
      if (!update) return
      update((prevState) => {
        const nextState = prevState.filter((_, i) => i !== index)
        return [...nextState]
      })
    },
    [setDailySchedules, setPreorderSchedules]
  )
}

export default useDeleteDefaultSchedule
